import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PageHeaderProps } from './PageHeader.types';

const StyledHeader = styled.div`
  margin: 0;

  > h1 {
    margin: 0;
    padding: 24px;
    background-color: #f2f2f2;
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 36px;
  }

  @media (max-width: 1000px) {
    > h1 {
      margin: 0;
      padding: 0.25rem 1rem;
      font-size: 1rem;
    }
  }
`;

const Description = styled.div`
  margin: 24px;
  overflow: hidden;
  white-space: pre-wrap;
  > p {
    margin: 0;
    padding: 0;
  }
`;
export const PageHeader: FunctionComponent<PageHeaderProps> = props => {
  return (
    <>
      <StyledHeader {...props}>
        <h1>{props.header}</h1>
        <Description>{props.description}</Description>
      </StyledHeader>
    </>
  );
};

PageHeader.defaultProps = {
  responsive: true,
};
